<template>
  <div id="app">
    <meta name="viewport" content="width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no">
    <router-view></router-view>
        <Tabbar v-if="showTabbar" />
  </div>
</template>
<script>
import Tabbar from './components/common/tabbar.vue'
export default {
    components: {
    Tabbar
  },
    computed: {
    showTabbar() {
      // 这里写你需要显示 Tabbar 的4个路由 path
      const showPages = [
        '/ykyCodeIndex',
        '/inspectionReport',
        '/userFeedback',
        '/activity'
      ]
      return showPages.includes(this.$route.path)
    }
  }
}
</script>
<style>
  html,body {
    background: #F5F6FA;
  }
</style>